import { H5, H6, Image } from 'AbstractElements';
import { Col, Card, CardHeader, Table, Media, Modal, ModalBody, Badge } from 'reactstrap';
import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { setFilters, setFormData } from 'Services/Features/Product/productSlice';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteProduct } from 'Services/Features/Product/Utils/productUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import CurrencyFormatter from 'Component/Common/Formatter/CurrencyFormatter';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import user1 from 'assets/images/user/1.jpg';
import ResponsiveDescriptionCell from './ResponsiveDescriptionCell';

const ProductTable = ({ setRefetch }) => {
    const products = useSelector((state) => state.product.products);
    const loading = useSelector((state) => state.product.loading);
    const pagination = useSelector((state) => state.product.pagination);
    const filters = useSelector(state => state.product.filters);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (src) => {
        setSelectedImage(src);
        setModalOpen(true);
    };

    const toggleModal = () => setModalOpen(!modalOpen);

        // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photo dan banner ke state terpisah
        dispatch(setFormData({ photoLink: item.photo }));

        // Buat objek baru tanpa banner
        const { photo, ...updatedItem } = item;

        dispatch(setFormData({
            ...updatedItem,
            category_id: item.category?.id,
        }));

        history(`${process.env.PUBLIC_URL}/product/edit/${item.id}`);
    };

    return (
        <Fragment>
        <Col sm="12" lg="12" xl="12">
            <Modal isOpen={modalOpen} toggle={toggleModal} centered size="lg">
                <ModalBody className="text-center">
                    <img src={selectedImage} alt="Preview" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                </ModalBody>
            </Modal>
            <Card>
            <CardHeader>
                <span>{'Kelola data produk, termasuk'} <code>deskripsi, cara penggunaan, harga promo, link marketplace(shopee, tokopedia, tiktok), dan foto produk.</code></span><span>{'Gunakan fitur pencarian dan filter untuk menemukan data lebih cepat.'}</span>
            </CardHeader>          
            <div className="mb-5">
                <Col sm="12" lg="12" xl="12">
                    <div className="table-responsive">
                    <Table className=" table-hover table-border-vertical">
                        <thead className="bg-primary">
                        <tr>
                            <th scope="col" className="sticky-col-number"style={{ verticalAlign: 'middle', width: '15px' }}>{'#'}</th>
                            <th scope="col" className="sticky-col-name" style={{ verticalAlign: 'middle', whiteSpace: 'nowrap', overflow: 'hidden' }}>{'Nama Produk'}</th>
                            <th scope="col" style={{ verticalAlign: 'middle'}}>{'Deskripsi'}</th>
                            <th scope="col" className="text-center" style={{ verticalAlign: 'middle', width: '100px' }}>{'Harga'}</th>
                            <th scope="col" className="text-center" style={{ verticalAlign: 'middle', width: '30px' }} >{'Platform Belanja'}</th>
                            <th scope="col" className="text-center" style={{ verticalAlign: 'middle', width: '15px' }} >{'Aksi'}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            products && products.map((item, i) => 
                            <tr key={item.id}>
                                <th className="sticky-col-number" scope="row" style={{ verticalAlign: "top" }}>{i + 1}</th>
                                <td className="sticky-col-name">
                                    <Media>
                                        <div className="me-2">
                                            <Image
                                                attrImage={{
                                                    title: 'Klik untuk melihat foto',
                                                    className: 'b-r-5',
                                                    style: { width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' },
                                                    src: item.photo ? item.photo : user1,
                                                    alt: item.name,
                                                    onClick: () => handleImageClick(item.photo ? item.photo : user1)
                                                }}
                                            />
                                        </div>
                                        <Media body className="ps-2">
                                            <div>
                                                <H5>
                                                    {item.name}
                                                </H5>
                                                <Badge color="success" className="badge" style={{ fontSize: '12px', padding: '4px 8px' }}>
                                                    {item.category?.name}
                                                </Badge>
                                            </div>
                                        </Media>
                                    </Media>
                                </td>
                                <ResponsiveDescriptionCell description={item.description} />
                                <td style={{ maxWidth: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                    {item.gimmick_price && (
                                        <span className="d-block" style={{ textDecoration: 'line-through', marginRight: '8px', color: 'red' }}>
                                        <CurrencyFormatter amount={item.gimmick_price} />
                                        </span>
                                    )}
                                    <CurrencyFormatter amount={item.price} />
                                </td>
                                <td>
                                        <div className="d-flex flex-column gap-2">
                                            {item.tiktok_url && (
                                                <Badge
                                                    color="dark"
                                                    pill
                                                    tag="a"
                                                    title={`Kunjungi Tiktok: ${item.tiktok_url}`}
                                                    href={item.tiktok_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-white text-decoration-none"
                                                >
                                                    <i className="fa fa-link"></i> Tiktok
                                                </Badge>
                                            )}
                                            {item.shopee_url && (
                                                <Badge
                                                    color="primary"
                                                    pill
                                                    tag="a"
                                                    title={`Kunjungi Shopee: ${item.shopee_url}`}
                                                    href={item.shopee_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-white text-decoration-none"
                                                >
                                                    <i className="fa fa-link"></i> Shopee
                                                </Badge>
                                            )}
                                            {item.tokopedia_url && (
                                                <Badge
                                                    color="success"
                                                    pill
                                                    tag="a"
                                                    title={`Kunjungi Tokopedia: ${item.tokopedia_url}`}
                                                    href={item.tokopedia_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-white text-decoration-none"
                                                >
                                                    <i className="fa fa-link"></i> Tokopedia
                                                </Badge>
                                            )}
                                        </div>
                                </td>
                                <td>
                                    <div className="d-flex">
                                        <button
                                        title="Edit"
                                        className="btn btn-primary"
                                        style={{ padding: '4px 8px', fontSize: '12px' }}
                                        onClick={() => handleEdit(item)}
                                        >
                                        <i className="fa fa-pencil"></i>
                                        </button>

                                        <button
                                        title="Hapus"
                                        className="btn btn-danger ms-2"
                                        style={{ padding: '4px 8px', fontSize: '12px' }}
                                        onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteProduct)}
                                        >
                                        <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            )
                        }
                        </tbody>
                    </Table>
                    </div>
                <div style={{ marginTop: '100px', display: 'flex', justifyContent: 'center' }}>
                    {loading === false && products && products.length > 0 && (
                    <PaginationComponent
                        pagination={pagination}
                        handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                        handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                    />
                    )}
                </div>
                </Col>
            </div>
            </Card>
        </Col>
        </Fragment>
    );
};

export default ProductTable;